import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
} from "react-router-dom";

import { useState } from "react";
import "./index.css";
import Dashboard from "./scenes/dashboard";
import Users from "./scenes/users";
import Inbox from "./scenes/inbox";
import SingleSend from "./scenes/singleSend";
import MultiSend from "./scenes/multiSend";
import Contacts from "./scenes/contacts";
import LoginForm from "./scenes/login/LoginForm";
import ProtectedRoutes from "./ProtectedRoutes";
import MessageSent from "./components/MessageSent";
import MessageFailed from "./components/MessageFailed";
import Form from "./scenes/form";
import Templates from "./scenes/templates";
import AddTemplate from "./scenes/addTemplate";
import ChangePass from "./scenes/changepass";

function App() {
  const [messageSent, setMessageSent] = useState(false);

  const handleMessageSent = () => {
    setMessageSent(true);
  };

  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route path="/" element={<LoginForm />} />
        <Route element={<ProtectedRoutes />}>
          <Route path="home" element={<Dashboard />} />
          <Route path="users" element={<Users />} />
          <Route path="contacts" element={<Contacts />} />
          <Route path="inbox" element={<Inbox />} />
          <Route path="templates" element={<Templates />} />
          <Route path="form" element={<Form />} />
          <Route path="add-template" element={<AddTemplate />} />
          <Route path="change-password" element={<ChangePass />} />
          <Route
            path="singleSend"
            element={<SingleSend onMessageSent={handleMessageSent} />}
          />
          <Route path="multisend" element={<MultiSend />} />
          <Route path="sent" element={messageSent ? <MessageSent /> : null} />
        </Route>
      </>
    )
  );

  return <RouterProvider router={router} />;
}

export default App;
